import React from 'react';
import { Box, Link, SvgIcon, Theme, Typography, useMediaQuery } from '@mui/material';
import { palette, spaces } from '../../assets/styles/themes/tokens';
import getMuiIcon, { IconName } from '../../utils/getMuiIcon';
import getTextTruncationSx from '../../utils/getTextTruncationSx';

type BreadcrumbsProps = {
  links: {
    title?: string;
    url?: string;
    iconName?: IconName;
  }[];
};

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ links }) => {
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('mobile'));
  const Separator = () => 
    <Typography 
      variant='body1' 
      sx={{ width: 7, height: 24 }} 
      data-testid='breadcrumbs-separator'>/</Typography>;

  return (
    <Box data-testid='breadcrumbs' sx={{
      display: 'flex',
      alignItems: 'center',
      height: 24,
      gap: spaces.xs,
    }}>
      {
        links.map(({ url, title, iconName }, index) => {
          const isLast = index === links.length - 1;
          const color = isLast ? palette.text.primary :  palette.primary.main;

          return (
            <React.Fragment key={index}>
              { 
                iconName &&
                <Link href={url}>
                  <SvgIcon 
                    component={getMuiIcon(iconName)} 
                    sx={{ color: color, width: 16, height: 16 }}
                    viewBox='0 0 16 16'
                  />
                </Link>
              }
              {
                isMobile && !isLast ? null : url ?
                  <Link href={url} sx={{ textDecoration: 'none' }}>
                    <Typography sx={{ color, whiteSpace: 'nowrap' }} variant='body2'>{title}</Typography>
                  </Link>
                  : <Typography sx={{ color, ...getTextTruncationSx() }} variant='body2'>{title}</Typography>
              }
              { !isLast && <Separator /> }
            </React.Fragment>
          );
        })
      }
    </Box>
  );
};

export default Breadcrumbs;
